import {
  createHistoryUploader,
  sleep,
  uploadParts,
  xhrPutPart,
  type HistoryUploader,
  type UploadPartsOptions,
} from '../lib/historyUpload'

// The Garmin card's history import (UserConnectedAppsLive): uploads the zip
// picked in any file input marked `data-garmin-history-zip`, in the modal or
// on the card. The logic is in lib/historyUpload.ts.

// The promise form: it rejects when the push fails (no connection, a
// timeout), where the callback form never calls back.
function pushEventWithReply(self: any) {
  return function pushEvent(event: string, payload: Record<string, unknown>): Promise<unknown> {
    return self.pushEvent(event, payload)
  }
}

function uploadPartsWithXhr(options: UploadPartsOptions) {
  return uploadParts(options, { putPart: xhrPutPart, sleep })
}

export const GarminHistoryUpload = {
  mounted() {
    const self = this as any

    const uploader: HistoryUploader = createHistoryUploader({
      pushEvent: pushEventWithReply(self),
      sleep,
      uploadParts: uploadPartsWithXhr,
    })
    self.uploader = uploader

    self.onChange = function onChange(event: Event) {
      const input = event.target
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-garmin-history-zip]')) {
        return
      }

      const file = input.files?.[0]
      if (!file) {
        return
      }

      input.value = ''
      uploader.start(file)
    }
    document.addEventListener('change', self.onChange)

    self.handleEvent('history_upload_abort', function onAbort(payload: { import_id: number }) {
      uploader.abort(payload.import_id)
    })

    self.onBeforeUnload = function onBeforeUnload(event: BeforeUnloadEvent) {
      if (document.getElementById('garmin-history-upload-progress')) {
        event.preventDefault()
      }
    }
    window.addEventListener('beforeunload', self.onBeforeUnload)
  },

  // The LiveView remounted: it shows the running upload again once told.
  reconnected() {
    const self = this as any
    self.uploader.reportState()
  },

  destroyed() {
    const self = this as any
    document.removeEventListener('change', self.onChange)
    window.removeEventListener('beforeunload', self.onBeforeUnload)
    self.uploader.stop()
  },
}
